import { types } from "@vilocnv/allsetra-core";

export interface MapViewPreferences {
  showSatelliteMode: boolean;
  showClusters: boolean;
  showTraffic: boolean;
  showGeozones: boolean;
  filters: types.IMapFilter;
}

export const DEFAULT_MAP_FILTERS: types.IMapFilter = {
  groups: [],
  objectTypes: [],
  keyId: []
};

export const DEFAULT_MAP_VIEW_PREFERENCES: MapViewPreferences = {
  showSatelliteMode: false,
  showClusters: true,
  showTraffic: false,
  showGeozones: true,
  filters: DEFAULT_MAP_FILTERS
};

export const MAP_PREFERENCES_VERSION = 1 as const;

export interface MapPreferencesRecord {
  version: typeof MAP_PREFERENCES_VERSION;
  userId: string;
  accountId: string;
  preferences: MapViewPreferences;
  updatedAt: string;
}

export type MapPreferencesStore = Record<string, MapPreferencesRecord>;

export const MAX_FILTER_IDS_PER_FIELD = 500;
